// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1JCnk","rootCenter":"LoadMoreObserver_rootCenter__1o0vM","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__170gU"};